
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^webpack_sharing_consume_default_react(\-dom_react\-dom|_react)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
